import { cn } from '@/lib/utils'
import { Loader2 } from 'lucide-react'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger'
  isLoading?: boolean
  children: React.ReactNode
}

export function Button({
  variant = 'primary',
  isLoading,
  children,
  className,
  disabled,
  ...props
}: ButtonProps) {
  const variants = {
    primary: 'bg-ink text-white hover:bg-wd-orange',
    secondary: 'border border-ink/30 text-carbon hover:border-ink hover:bg-ink hover:text-white',
    ghost: 'text-carbon hover:text-wd-orange',
    danger: 'border border-red-600 text-red-600 hover:bg-red-600 hover:text-white',
  }

  return (
    <button
      className={cn(
        'inline-flex items-center justify-center gap-2 px-6 py-3 text-xs font-medium normal-case tracking-[0.12em] transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-wd-orange disabled:opacity-50 disabled:cursor-not-allowed',
        variants[variant],
        className
      )}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading && <Loader2 className="h-4 w-4 animate-spin" />}
      {children}
    </button>
  )
}
